<template>
    <div>
        <rkm-modal
            large
            ref="RkmModal"
            title="Adicionar exame"
        >

            <rkm-form
                ref="Form"
                show-legend
            >
                <rkm-row>
                    <rkm-col cols="12">
                        <rkm-form-input-autocomplete
                            :repository="repositories.exame"
                            :searchFields="fields.autocompletes.exame"
                            :request-query-string-params="autocompleteQueryStringParams.exame"
                            :text-field="e => e.codigo ? `${e.codigo} - ${e.nome}` : `${e.nome}`"
                            :validations="validations.exame"
                            label="Exame"
                            v-model="exame"
                        />
                    </rkm-col>

                    <rkm-col class="flex-grow-0">
                        <rkm-form-checkbox
                            v-model="solicitado"
                            :validations="validations.solicitado"
                            inline
                        >
                            Solicitado
                        </rkm-form-checkbox>
                    </rkm-col>

                    <rkm-col class="flex-grow-0">
                        <rkm-form-checkbox
                            v-model="avaliado"
                            :validations="validations.avaliado"
                            inline
                        >
                            Avaliado
                        </rkm-form-checkbox>
                    </rkm-col>
                </rkm-row>
            </rkm-form>

            <template v-slot:footer>
                <rkm-button @click="handleCancel">
                    Fechar
                </rkm-button>

                <rkm-button
                    @click="save"
                    color="primary"
                >
                    {{ index == null ? 'Incluir' : 'Alterar' }}
                </rkm-button>
            </template>
        </rkm-modal>
    </div>
</template>

<script>

// Mixins.
import { repository, stringCase, object, formats } from '@/mixins'

export default {
    computed: {
        fields() {
            return {
                tables: {
                    medicamentos: [
                        { key: 'data', label: 'Data', class: 'col-min', sortable: true },
                        { key: 'usoMedicamento', label: 'Medicamento', sortable: true },
                    ],
                },
                autocompletes: {
                    exame: [
                        { key: 'codigo', searchable: true },
                        { key: 'nome', searchable: true }
                    ],
                }
            }
        },
        validations() {

            return {
                exame: { required: true },
                solicitado: { required: true },
                avaliado: { required: true },
            }
        },
        autocompleteQueryStringParams() {

            return {
                exame: {
                    paciente_id: this.data.model.cidadao.pacienteId,
                    atencao_basica_cadastro_exame_solicitado_avaliado: true,
                    atencao_basica_cadastro_triagem_neonatal: true,
                    with_codigo_ab: true,
                }
            }
        },
    },
    created() {
        this.repositories = {
            exame: this.getConectaSusRepository('parametrizacao.exame'),
        }
    },
    data: () => ({
        items: [],
        exame: null,
        index: null,
        solicitado: false,
        avaliado: false,
    }),
    methods: {
        open(index, item) {

            if (!(index === undefined || index === null)) {
                this.index = index
            }

            if (item) {

                this.exame = {
                    id: item.exameId ?? item.procedimentoAbexId,
                    codigo: item.codigo,
                    nome: item.exameNome,
                    origem: item.origem ?? 'parametrizacao_exame',
                }

                this.avaliado = item.avaliado
                this.solicitado = item.solicitado
            }

            this.$refs.RkmModal.show()
        },
        save() {

            this.$refs.Form.validate().then(valid => {

                if (!valid) return

                if (!this.avaliado && !this.solicitado) {

                    this.showValidationNotification('É necessário informar se o exame foi avaliado ou solicitado.')

                    return false
                }

                if (this.handleExames()) {

                    this.showValidationNotification('A operação não é permitida, pois o limite de 100 exames foi atingido.')

                    return false
                }

                const origem = this.exame.origem ?? 'parametrizacao_exame'

                const existe = this.data.model.atendimento.outrosExames.find((exame, index) =>
                    (exame.origem ?? 'parametrizacao_exame') === origem
                    && (exame.exameId ?? exame.procedimentoAbexId) == this.exame.id
                    && index !== this.index)

                if (existe) {

                    this.showValidationNotification('O exame já foi cadastrado anteriormente na ficha.')

                    return false
                }

                const param = {
                    origem,
                    exameId: origem === 'parametrizacao_exame' ? this.exame.id : null,
                    procedimentoAbexId: origem === 'abex' ? this.exame.id : null,
                    exameNome: this.exame.nome,
                    codigo: this.exame.codigo,
                    avaliado: this.avaliado,
                    solicitado: this.solicitado,
                }

                if (this.index !== null) {

                    this.$set(this.data.model.atendimento.outrosExames, this.index, this.clone(param))
                } else {

                    this.data.model.atendimento.outrosExames.push(this.clone(param))
                }

                this.resetForm()

                this.$refs.RkmModal.hide()
            })
        },
        resetForm() {

            this.index = null
            this.exame = null
            this.avaliado = null
            this.solicitado = null
        },
        handleExames() {

            const outrosExames = this.data.model.atendimento.outrosExames
            const exameSolicitadoAvaliado = this.data.model.atendimento.exameSolicitadoAvaliado
            const triagemNeonatal = this.data.model.atendimento.triagemNeonatal

            let total = 0

            triagemNeonatal.forEach((item, index) => {

                let id = item.replace('s_', '').replace('a_', '')
                let existe = triagemNeonatal.find((registro, i) => registro == id && i != index)

                if (!existe) {
                    total++;
                }
            });

            exameSolicitadoAvaliado.forEach((item, index) => {

                let id = item.replace('s_', '').replace('a_', '')
                let existe = exameSolicitadoAvaliado.find((registro, i) => registro == id && i != index)

                if (!existe) {
                    total++;
                }
            });

            outrosExames.forEach((item, index) => {

                let id = item.exameId
                let existe = outrosExames.find((registro, i) => registro == id && i != index)

                if (!existe) {
                    total++;
                }
            });

            if (total >= 100) {
                return true;
            }

            return false;
        },
        handleCancel() {

            this.resetForm()
            this.$refs.RkmModal.hide()
        }
    },
    mixins: [ repository, stringCase, object, formats ],
    props: {
        data: { type: Object, required: false },
    }
}
</script>

<style scoped>
.warning {
    color: var(--warning);
}
</style>